import React, { Component } from 'react';
import { Collapse } from 'react-bootstrap';

export class CollapsablePanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            panelOpen: true,
        };
    }
    render() {
        return(

                    <div className="ibox float-e-margins" >
                        <div className="ibox-title">
                            <h5>{this.props.title}</h5>
                            <div className="ibox-tools">
                                <a className="collapse-link">
                                    <i className={this.state.panelOpen ? 'fa fa-chevron-up' : 'fa fa-chevron-down'} onClick={ ()=> this.setState({ panelOpen: !this.state.panelOpen })}></i>
                                </a>
                                {/*
                                <a className="dropdown-toggle" data-toggle="dropdown" >
                                    <i className="fa fa-wrench"></i>
                                </a>
                                <ul className="dropdown-menu dropdown-user">
                                    <li><a >Config option 1</a>
                                    </li>
                                    <li><a >Config option 2</a>
                                    </li>
                                </ul>
                                <a className="close-link">
                                    <i className="fa fa-times"></i>
                                </a>
                              */}
                            </div>
                        </div>
                        <Collapse in={this.state.panelOpen}>
                        <div className="ibox-content" >
                            {this.props.children}
                        </div>
                        </Collapse>
                    </div>
            );
    }
}
;



// WEBPACK FOOTER //
// ./src/components/CollapsablePanel.js